import React, { useState } from "react";
import classes from "../Management.module.scss";
import styles from "./DealerPipeline.module.scss";
import { ageLabel } from "./dealerAdmin";

/**
 * "Waiting on the dealer": starts a clock the board shows, so a slow dealer in
 * Japan doesn't read as us going quiet. The customer sees only that we're
 * waiting on the dealer and since when; the note is for staff.
 *
 * Props: dealerAsk ({ askedAt, note }), onSave({ waitingOnDealer, dealerAskNote }) -> Promise<boolean>
 */
const DealerWaitBox = ({ dealerAsk, onSave }) => {
  const [note, setNote] = useState(null);
  const [busy, setBusy] = useState(false);
  const ask = dealerAsk || {};

  const save = async (body) => {
    setBusy(true);
    const ok = await onSave(body);
    setBusy(false);
    if (ok) setNote(null);
  };

  if (ask.askedAt) {
    return (
      <div className={styles.inlineRow}>
        <span className={`${styles.chip} ${styles.chipWarn}`}>Waiting on dealer · {ageLabel(ask.askedAt)}</span>
        {ask.note && <span className={styles.hint}>{ask.note}</span>}
        <button type="button" className={styles.btnText} disabled={busy} onClick={() => save({ waitingOnDealer: false })}>Dealer replied</button>
      </div>
    );
  }
  if (note === null) {
    return (
      <div className={styles.inlineRow}>
        <button type="button" className={styles.btn} onClick={() => setNote("")}>Waiting on the dealer</button>
        <span className={styles.hint}>Shows the customer we're on it while the dealer answers.</span>
      </div>
    );
  }
  return (
    <div className={styles.subForm}>
      <div className={classes.formGroup}>
        <label className={classes.formLabel} htmlFor="dealer-ask">What did we ask? (staff only)</label>
        <input id="dealer-ask" className={classes.formInput} value={note} placeholder="e.g. Price, timing belt record, underbody photos" onChange={(e) => setNote(e.target.value)} />
      </div>
      <div className={classes.formButtons} style={{ alignItems: "center" }}>
        <button type="button" className={`${styles.btn} ${styles.btnPrimary}`} disabled={busy} onClick={() => save({ waitingOnDealer: true, dealerAskNote: note.trim() })}>
          Start the clock
        </button>
        <button type="button" className={styles.btnText} disabled={busy} onClick={() => setNote(null)}>Cancel</button>
      </div>
    </div>
  );
};

export default DealerWaitBox;
